/* eslint no-unused-vars: 0 */

import React from "react"

class AdminSearchTermResults extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.displayResults === true) {
      var add_product =
        this.props.create_product_promotion === true ? (
          <li
            key={"asdasdasd"}
            onClick={() => {
              this.props.setSearchTerm(this.props.query_term, "Product");
            }}
          >
            <span className="label product">Product</span>
            {this.props.query_term.substring(0, 45)}{" "}
            {this.props.query_term.length >= 45 ? "... " : ""}
            <span className="label add-term pull-right">Add Term</span>
            <span className="pull-right">
              {this.props.create_product_promotion_count}{" "}
              {this.props.create_product_promotion_count == 1
                ? "Product"
                : "Products"}{" "}
              Found
            </span>
          </li>
        ) : (
          ""
        );

      var add_product_category =
        this.props.create_product_category_promotion === true ? (
          <li
            key={"asdasdjxasdasd"}
            onClick={() => {
              this.props.setSearchTerm(
                this.props.query_term,
                "Product Category"
              );
            }}
          >
            <span className="label product category">Product Category</span>
            {this.props.query_term.substring(0, 45)}{" "}
            {this.props.query_term.length >= 45 ? "... " : ""}
            <span className="label add-term pull-right">Add Term</span>
            <span className="pull-right">
              {this.props.create_product_category_promotion_count}{" "}
              {this.props.create_product_category_promotion_count == 1
                ? "Category"
                : "Categories"}{" "}
              Found
            </span>
          </li>
        ) : (
          ""
        );
      return (
        <div className="promoted--results">
          <ul>
            {add_product}
            {add_product_category}
            {this.props.results.map((term, index) => {
              return (
                <li
                  key={index}
                  onClick={() => {
                    this.props.setSearchTerm(term.term, term.type);
                  }}
                >
                  <span className={"label " + term.type.toLocaleLowerCase()}>
                    {term.type}
                  </span>{" "}
                  {term.term.substring(0, 45)}{" "}
                  {term.term.length >= 45 ? "... " : ""}
                  <span className="label edit-term pull-right">Edit Term</span>
                  <span className="pull-right">
                    {term.count}/{term.total}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

export default AdminSearchTermResults;
